<script lang="ts">
	import SbRichtext from '../components/sbRichtext.svelte';
	import type { SbLink, StripeProductData } from '../types';
	import Button from '$lib/buttons/v3/button.svelte';
	import { getSbUrl } from '$lib/utils/storyblok/url';
	import PageGrid16 from '../components/pageGrid16.svelte';
	import { editable } from '../editable';
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import Blok from '../blok.svelte';
	import { checkoutSession } from '$lib/state/checkoutSession.svelte';
	import { shoppingCart } from '$lib/state/shoppingCart.svelte';

	interface Props {
		content: ISbStoryData<{
			headline: string | ISbRichtext;
			faq_items: ISbStoryData[];
			text_color: string;
			cta_title?: string;
			cta_link: SbLink;
			bundle_id?: string;
			product?: StripeProductData;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<section use:editable={content} class="text-brown-1">
	<PageGrid16 class="max-lg:px-5">
		<div
			class="col-span-full flex flex-col lg:col-start-4 lg:col-end-[14] xl:col-start-5 xl:col-end-13"
		>
			{#if content.headline}
				<h1
					class="mb-4 text-[32px]/[110%] font-semibold tracking-[-.32px] lg:text-[48px]/[110%] lg:tracking-[-.48px]"
				>
					<SbRichtext text={content.headline} />
				</h1>
			{/if}

			{#each content.faq_items as faqItem}
				<div
					class="border-b-[0.5px] border-stone-2 last:border-none text-{content.text_color ||
						'brown-2'}"
				>
					<Blok content={faqItem} />
				</div>
			{/each}

			{#if content.cta_title && content.cta_title.length > 0}
				<div class="mt-4 lg:mt-10 lg:flex">
					<Button
						class="btn-large"
						{...content.product
							? {
									onclick: () => {
										checkoutSession.select(content.product!, {
											productBundle: content.bundle_id
										});
										shoppingCart.open();
									}
								}
							: {
									href: getSbUrl(content.cta_link)
								}}>{content.cta_title}</Button
					>
				</div>
			{/if}
		</div>
	</PageGrid16>
</section>
